export default "__VITE_ASSET__CoEOJwkl__"